import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import CityApi from '../api/city/city.ts';

export const fetchCitiesAsync = createAsyncThunk(
    'cities/fetchCities',
    async () => {
        const response = await CityApi();
        return response;
    }
);

const citySlice = createSlice({
    name: 'cities',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCitiesAsync.fulfilled, (state, action) => {
            state.data = action.payload;
            state.loading = false;
            state.error = null;
        });
        builder.addCase(fetchCitiesAsync.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(fetchCitiesAsync.rejected, (state, action) => {
            state.loading = false;
            state.error = action.error.message;
        });
    },
});

export default citySlice.reducer;